import React from 'react';
import EtelAPI from '../api/EtelAPI';
import Alerts from '../prototypes/Alerts';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// LinkedFields are dropdowns that populate based on another (none) linked dropdown, this component is 
// ment as a replacement to an EditSectionLinkedDropdown, they set the value on the parent field being changed
// and LinkedFields can be linked together.

// Supports drawing as dropdown, staticdropdowns, textbox
class EditSectionLinkedField extends React.Component {

  // -- Usage in layout --
  /* { 
      "column": "DESCRIPTION", 
      "label": "Description", 
      "type": "linkedfield", 
      "datatype":"varchar", 
      "routes":{ "route":"programs?PDNIS={}", "id":"COUNTRY_CODE" }, 
      "parentcolumn": "GROUP_NAME",
      "render_as": "dropdown"
      "datasize":255, 
      "searchable": false 
  } */

  // @arg: routes[object] -> Specify which value to replace on change of parent, anything in :key: will be replace with the 
  //        value of parent. :key: can be omitted if no field is to be replaced.
  // @arg: parentcolumn[str] -> The name of the parent field.
  // @arg: render_as[str] -> Renders the result field, by default it is a dropdown. Available types are textbox, dropdown


  constructor( props ){
    super( props );
    this.state = {
      columnName: this.props.columnName === undefined ? '' : this.props.columnName,
      
      id: this.props.id === undefined ? '' : this.props.id,
      height: this.props.height === undefined ? '32px' : this.props.height,
      width: this.props.width === undefined ? 'auto' : this.props.width,
      options: this.props.options === undefined ? [] : this.props.options,
      value: this.props.value === undefined ? '' : this.props.value,
      readonly: this.props.readonly === undefined ? false : true,
      visible: this.props.visible === undefined ? true : this.props.visible,
      route: this.props.route === undefined ? '' : this.props.route,
      render_as: this.props.render_as === undefined ? 'dropdown': this.props.render_as,
      option_id: this.props.opt_id === undefined ? '' : this.props.opt_id,
      option_text: this.props.opt_text === undefined ? '' : this.props.opt_text,
      
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.onNewValue = this.onNewValue.bind( this );
    this.onChange = this.onChange.bind( this );
    this.setOptions = this.setOptions.bind( this );
  }

  // Error detection
  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( newprops ){
    if( newprops.value !== undefined ){
      if( typeof( newprops.value ) === 'object' ){
        this.onNewValue( newprops.value );
      } else {
        this.setState( {
          value: newprops.value
        } );
      }
    }

    this.setState( {
      columnName: newprops.columnName === undefined ? '' : newprops.columnName,
      id: newprops.id === undefined ? '' : newprops.id,
      height: newprops.height === undefined ? '32px' : newprops.height,
      width: newprops.width === undefined ? 'auto' : newprops.width,
      readonly: newprops.readonly === undefined ? false : newprops.readonly,
      visible: newprops.visible === undefined ? true : newprops.visible,
      options: newprops.options === undefined ? [] : newprops.options,
      option_id: newprops.opt_id === undefined ? '' : newprops.opt_id,
      option_text: newprops.opt_text === undefined ? '' : newprops.opt_text
    } );
  }

  // On the value changin (external), this can only be called by ListContainer
  onNewValue( value ){
    if( this.props.onChanged !== undefined && typeof( value ) === 'object' ){
      if( this.state.route !== '' ){
        const Bugsnag = this.props.bugsnag;
        const { dispatch } = this.props;
        const alerts = new Alerts( Bugsnag, dispatch );
        const onnew_route = this.state.route;
        let route = onnew_route.route;

        if( route !== undefined ){

          // Replacing the values in route with key's values
          const allkeys = Object.keys( value );
          for( let i = 0; i < allkeys.length; i++ ){
            const key = allkeys[i]; 
            route = route.replace( ':' + key + ':', value[key] );
          }

          // Setting the value of pgm_voicefiles_linkedoptions
          let api = new EtelAPI( route );

          // Gets a list of options available
          api.getlist( route ).then( ( result ) => {
            this.setOptions( result, value, onnew_route.id );
          } ).catch( ( error ) => {
            alerts.CRITICAL( 'Route error', error ); 
          } );
        
        }
      } else {
        let payload = {};
        
        payload['target'] = this;
        payload['target']['value'] = value;
        payload['columnName'] = this.state.columnName;

        this.props.onChanged( payload );

        this.setState( {value: value} );
      }
    }
  }


  // Updates the available options
  setOptions( result, value, id ){

    const render_as = this.state.render_as;
    let update = {};

    // If a route exist
    if( this.state.route !== '' || this.state.route !== undefined ){
      
      // Format is one json object
      if( result.length !== 0 ){
        
        // Textbox and Staticdropdown values
        if( render_as === 'staticdropdown' || render_as === 'textbox' ){
          update['value'] = result[0][id];
        
        // Dropdown options
        } else if( this.state.render_as === 'dropdown' ){

          let options = [];
          
          for( let x = 0; x < result.length; x++ ){
            const lvalue = result[x][id];

            if( lvalue !== undefined ){
              options.push( lvalue );
            }
          }

          update['options'] = options;
        }
      } else {
        update['value'] = value;
      }
    } else {
      update['value'] = value;
    }

    this.setState( update );

    if( this.props.onChanged !== undefined ){
      let payload = {};
      payload['target'] = this;
      
      if( update['value'] !== undefined ){
        payload['target']['value'] = update['value'];
      } else {
        payload['target']['value'] = value;
      }

      payload['columnName'] = this.state.columnName;

      this.props.onChanged( payload );
    }
  }

  // On the value changing (internal)
  onChange( e ){

    let payload = {};
    payload['target'] = this;
    payload['target']['value'] = e.target.value;
    payload['columnName'] = this.state.columnName;
    
    this.setState( {value: e.target.value} );

    if( this.props.onChanged !== undefined ){
      this.props.onChanged( payload );
    }
  }


  // Rendering the value
  render(){

    const alert = this.state.alert;
    let options = this.state.options === undefined ? [] : this.state.options;
    const id = this.state.id;
    const height = this.state.height;
    const width = this.state.width;
    let value = this.state.value === undefined ? '' : this.state.value;

    // Fixes option not bring in the value
    if( options.length > 0 && value === '' && this.state.render_as === 'dropdown' ){
      value = options[0];
    }

    let styles = {
      'width': width,
      'height': height,
      'fontSize': '100%'
    };

    let className = ( alert === true ? 'edit-section-dropdown alert' : 'edit-section-dropdown' );

    let readonly = this.state.readonly;
    let opts = {};

    if( readonly === true ) {
      opts['disabled'] = this.state.readonly.toString();
    }
    opts['value'] = this.state.value;

    if( ( this.state.visible === false ) || ( this.state.hasError === true ) ) {
      return(
        <div></div>
      );

    } else {


      if( this.state.render_as === 'dropdown' || this.state.render_as === 'staticdropdown' ){
        if ( options.length === 0 ) {
          return (
            <select key={id} id={id} className={className} style={styles} onChange={this.onChange} {...opts} >
              <option key={value + '_0'} value={this.state.value}> {this.state.value} </option>
            </select>
          );
        } else {

          let key = '';
          let optionItems;

          optionItems = options.map( ( option, index ) => {
            key = 'edit-section-linked-options-' + index.toString();

            if( this.state.option_id !== '' && this.state.option_text !== '' ){
              if( option[this.state.option_id] === value ){
                return ( <option key={key} value={option[this.state.option_id]} defaultValue>{option[this.state.option_text]}</option> );
              } else {
                return ( <option key={key} value={option[this.state.option_id]}>{option[this.state.option_text]}</option> );
              }
            } else {
              return ( <option key={key} value={option}>{option}</option> );
            }
          } );
          return (
            <select key={id} id={id} className={className} style={styles} onChange={this.onChange} {...opts}>
              {optionItems}
            </select>
          );
        }
      } else if( this.state.render_as === 'textbox' ) {
        let styles = {
          'width': width,
          'height': height,
          'fontSize': '100%',
        };
        
        return (
          <input
            id={id}
            type="text"
            className='edit-section-input'
            style={styles}
            value={this.state.value}
            onChange={this.onChange}
            {...opts} /> );
      }
    }
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( EditSectionLinkedField ) );


// WEBPACK FOOTER //
// ./src/presentation/EditSectionLinkedField.js